import { sva } from "@agapi/ui/panda/css";
export const loader = sva({
    slots: ['wrapper', 'loader'],
    base: {
        wrapper: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '1.2em',
            height: '1em',
        },
        loader: {
            display: 'inline-block',
        },
    },
    variants: {
        type: {
            spinner: {
                loader: {
                    boxSizing: 'border-box',
                    width: '1em',
                    height: '1em',
                    rounded: '50%',
                    border: '0.1618em solid color-mix(in srgb, currentColor 33%, transparent)',
                    borderTopColor: 'currentColor',
                    animation: 'spin 1.2s linear infinite',
                },
            },
            dots: {
                loader: {
                    display: 'inline-block',
                    borderRadius: '50%',
                    animationFillMode: 'both',
                    animation: 'bblFadInOut 1.8s infinite ease-in-out',
                    width: '0.3em',
                    height: '0.3em',
                    position: 'relative',
                    top: '-0.3em',
                    textIndent: '-9999em',
                    transform: 'translateZ(0)',
                    animationDelay: '-0.16s',
                    _before: {
                        content: "''",
                        position: 'absolute',
                        top: 0,
                        left: '-0.4em',
                        width: '0.3em',
                        height: '0.3em',
                        animationDelay: '-0.32s',
                        borderRadius: '50%',
                        animationFillMode: 'both',
                        animation: 'bblFadInOut 1.8s infinite ease-in-out',
                    },
                    _after: {
                        content: "''",
                        position: 'absolute',
                        top: 0,
                        left: '0.4em',
                        width: '0.3em',
                        height: '0.3em',
                        borderRadius: '50%',
                        animationFillMode: 'both',
                        animation: 'bblFadInOut 1.8s infinite ease-in-out',
                    },
                },
            },
            heart: {
                loader: {
                    position: 'relative',
                    width: '0.5em',
                    height: '0.75em',
                    animation: 'heartBeat 1.2s infinite cubic-bezier(0.215, 0.61, 0.355, 1)',
                    _before: {
                        content: '""',
                        background: 'currentColor',
                        width: '0.5em',
                        height: '0.75em',
                        borderRadius: '1.5625em 1.5625em 0 0',
                        position: 'absolute',
                        left: '0',
                        bottom: '0',
                        transform: 'rotate(45deg)',
                        transformOrigin: '50% 68%',
                    },
                    _after: {
                        content: '""',
                        background: 'currentColor',
                        width: '0.5em',
                        height: '0.75em',
                        borderRadius: '3.125em 3.125em 0 0',
                        position: 'absolute',
                        left: '0',
                        bottom: '0',
                        transform: 'rotate(-45deg)',
                        transformOrigin: '50% 68%',
                    },
                },
            },
        },
        size: {
            xs: { wrapper: { fontSize: '2xs' } },
            sm: { wrapper: { fontSize: 'md' } },
            md: { wrapper: { fontSize: 'xl' } },
            lg: { wrapper: { fontSize: '3xl' } },
            xl: { wrapper: { fontSize: '5xl' } },
            '2xl': { wrapper: { fontSize: '7xl' } },
        },
    },
    defaultVariants: {
        type: 'spinner',
        size: 'md',
    },
});
